/**
 * ID messaggi PWA (allineati a `lingui compile` / `messages.po`).
 * Lookup diretto su `i18n.messages` per evitare hash visibili se il catalogo non è sincronizzato.
 */
export const PWA_UPDATE_MESSAGE_IDS = {
  title: 'CifUuG',
  body: '6J3eWG',
  later: 'FIq1Ba',
  reload: 'IoAVFL',
  offlineReady: 'hrh1Xs'
}

/** Fallback leggibile (inglese) se il catalogo attivo non contiene la chiave. */
export const PWA_UPDATE_DEFAULTS = {
  title: 'Update available',
  body:
    'A new version of ADaMS is available. Reload to use the latest features and fixes.',
  later: 'Later',
  reload: 'Reload to update',
  offlineReady: 'App is ready to work offline'
}

/**
 * @param {Record<string, unknown> | undefined} catalog
 * @param {string} id
 * @param {string} fallback
 * @returns {string}
 */
export function resolvePwaCatalogMessage(catalog, id, fallback) {
  if (!catalog || typeof catalog !== 'object') {
    return fallback
  }

  const value = catalog[id]

  if (typeof value === 'string' && value.length > 0 && value !== id) {
    return value
  }

  return fallback
}

/**
 * @param {import('@lingui/core').I18n} i18n
 * @returns {{
 *   title: string,
 *   body: string,
 *   later: string,
 *   reload: string,
 *   offlineReady: string
 * }}
 */
export function getPwaUpdateCopy(i18n) {
  const catalog = i18n.messages

  return {
    title: resolvePwaCatalogMessage(
      catalog,
      PWA_UPDATE_MESSAGE_IDS.title,
      PWA_UPDATE_DEFAULTS.title
    ),
    body: resolvePwaCatalogMessage(
      catalog,
      PWA_UPDATE_MESSAGE_IDS.body,
      PWA_UPDATE_DEFAULTS.body
    ),
    later: resolvePwaCatalogMessage(
      catalog,
      PWA_UPDATE_MESSAGE_IDS.later,
      PWA_UPDATE_DEFAULTS.later
    ),
    reload: resolvePwaCatalogMessage(
      catalog,
      PWA_UPDATE_MESSAGE_IDS.reload,
      PWA_UPDATE_DEFAULTS.reload
    ),
    offlineReady: resolvePwaCatalogMessage(
      catalog,
      PWA_UPDATE_MESSAGE_IDS.offlineReady,
      PWA_UPDATE_DEFAULTS.offlineReady
    )
  }
}
